import React from "react";

const DashboardFooter = () => {
    return (
        <div className="mt-8 pt-4 border-t border-border">
            <div className="px-3 text-xs text-muted-foreground">
                <span>&copy; {new Date().getFullYear()} My Portfolio</span>
            </div>
        </div>
    );
};

export default DashboardFooter;